import { Event } from '../types';

export const openFacetEvent = new Event<{ elementId: string, componentId: string }>();